import PropTypes from 'prop-types';

const Menu = ({ color, size, ...props }) => (
    <svg viewBox="0 0 28 28" width={size} height={size} {...props}>
        <path
            d="M26 4a1.5 1.5 0 0 1 .145 2.993L26 7H2a1.5 1.5 0 0 1-.144-2.993L2 4zm0 8a1.5 1.5 0 0 1 .145 2.993L26 15H2a1.5 1.5 0 0 1-.144-2.993L2 12zm0 8a1.5 1.5 0 0 1 .145 2.993L26 23H2a1.5 1.5 0 0 1-.144-2.993L2 20z"
            fill={color}
        />
    </svg>
);

export default Menu;

Menu.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
